import _ from 'lodash'

export default class Enum {

  list = {}

  constructor(list) {
    this.list = list
    _.forEach(list, (item, key) => {
      this[key] = item.value
    })
  }

  label(value) {
    const item = _.find(this.list, enumItem => enumItem.value == value)
    return item ? item.label: ''
  }

  getList() {
    return _.map(this.list, item => ({
      label: item.label,
      value: item.value
    }))
  }
}
